export function goToNextPage(slug) {
    location.href = slug;
}
